import { render, staticRenderFns } from "./DannyProfileModal.vue?vue&type=template&id=1290d518&scoped=true&"
import script from "./DannyProfileModal.vue?vue&type=script&lang=js&"
export * from "./DannyProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./DannyProfileModal.vue?vue&type=style&index=0&id=1290d518&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1290d518",
  null
  
)

export default component.exports